module.exports = __webpack_public_path__ + "/images/guest-full-screenshot.b1375a6.webp";